import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "totalIncome",
  "use": "totalIncome-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"totalIncome\"><style>#totalIncome .st0{fill:none}#totalIncome .st1{fill-rule:evenodd;clip-rule:evenodd}</style><title>累计收入</title><path id=\"totalIncome_Clip-6\" class=\"st0\" d=\"M0 16h16V0H0z\" /><g id=\"totalIncome_编组\"><path id=\"totalIncome_Fill-1\" class=\"st1\" d=\"M9.9 11.1c.2 0 .4.2.4.4s-.2.4-.4.4H8.1V13c0 .2-.2.4-.4.4s-.4-.2-.4-.4v-1.1H5.6c-.2 0-.3-.1-.4-.2-.1-.1-.1-.3 0-.4.1-.1.2-.2.4-.2h1.7v-.5H5.6c-.2 0-.3-.1-.4-.2-.1-.1-.1-.3 0-.4.1-.1.2-.2.4-.2h1.2L5.6 7.6v-.3c0-.1.1-.2.1-.3.2-.1.5-.1.6.1l1.4 2.6h.1l1.4-2.5c.1-.2.4-.3.6-.2.1.1.2.2.2.3v.3L8.8 9.7h1.1c.2 0 .4.2.4.4s-.2.4-.4.4H8.1v.5h1.8zm-.4-5.8H6c-3.9 0-4.9 7.6-4.9 7.6 0 1 .8 1.9 1.8 2h9.5c1-.1 1.8-1 1.8-2 .1 0-.9-7.6-4.7-7.6zM6 4.6h3.3c1 0 1.8-2.2 1.8-2.2 0-.7-.1-1.2-1.2-1.2-1.1-.1-1.4.8-2.2.8s-1.3-.7-2.3-.8-1.2.5-1.2 1.2c0 0 .7 2.2 1.8 2.2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/totalIncome.svg
// module id = r/zG
// module chunks = 6